import { CONFIRMATION_TYPES } from "../../data/confirmationTypes";
import { useSourceSystem } from "../../hooks/useSourceSystem";
import { CustomerConfirmationData } from "../../types/CustomerConfirmation";

export const useCustomerConfirmation = (confirmationType: string) => {
  const {
    sourceSystem: { stepCount }
  } = useSourceSystem();

  const redirectToAcDotCom = () =>
    (window.location.href = process.env.REACT_APP_AC_DOT_COM!);
  const customerConfirmationDetails: {
    [key: string]: CustomerConfirmationData;
  } = {
    [CONFIRMATION_TYPES.EMAIL]: {
      title: "Your valuation has been emailed to you",
      onSubmit: redirectToAcDotCom,
      buttonCopy: "Back to homepage",
      analyticsLabel: "Back to homepage - email offer"
    },
    [CONFIRMATION_TYPES.TRADE_IN]: {
      title: "We’ve saved your valuation",
      subtitle: "Use your valuation to build a deal on your next car",
      onSubmit: redirectToAcDotCom,
      buttonCopy: "Start my search",
      analyticsLabel: "Start my search - saved valuation"
    }
  };

  return {
    customerConfirmationDetails: customerConfirmationDetails[confirmationType],
    stepCount,
    readyToRender: Boolean(
      customerConfirmationDetails[confirmationType] && stepCount
    )
  };
};
